import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import ApiUsage from './ApiUsage';
import UserManagement from './UserManagement';
import AuditLogs from './AuditLogs';
import PlatformActivity from './PlatformActivity';
import OrganizationManagement from './OrganizationManagement';
import './AdminDashboard.css';
import '../workspace/Members.css';

const AdminDashboard = ({ initialTab, currentUser, refreshProfile }) => {
  const [searchParams] = useSearchParams();

  const mapInitialTab = (tab) => {
    if (tab === 'dashboard' || !tab) return 'users';
    if (tab === 'credits') return 'api-usage';
    if (tab === 'user-management') return 'users';
    if (tab === 'audit-logs') return 'audit-logs';
    if (tab === 'platform-activity') return 'platform-activity';
    return tab;
  };

  const [activeTab, setActiveTab] = useState(mapInitialTab(initialTab));

  useEffect(() => {
    const queryTab = searchParams.get('tab');
    if (queryTab) {
      setActiveTab(queryTab);
    } else if (initialTab) {
      setActiveTab(mapInitialTab(initialTab));
    }
  }, [initialTab, searchParams]);

  const isSuperadmin = currentUser?.isSuperadmin;

  return (
    <div className="admin-dashboard-container">
      {/* Tab Content */}
      <div className="admin-content-area" style={{ marginTop: 0 }}>
        {activeTab === 'api-usage' && <ApiUsage />}
        {activeTab === 'users' && (
          <UserManagement activeTab={activeTab} setActiveTab={setActiveTab} />
        )}
        {activeTab === 'audit-logs' && (
          <AuditLogs activeTab={activeTab} setActiveTab={setActiveTab} />
        )}
        {activeTab === 'platform-activity' && (
          <PlatformActivity activeTab={activeTab} setActiveTab={setActiveTab} />
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
